import Axios from 'axios';
import Qs from 'qs';

export default {
	//巡检任务列表
	listPage(
		//这里是列表的名称
		community_id,
		device_type_id,
		task_name,
		task_state,
		task_start_date,
		task_end_date,
		page,
		limit
	) {
		return Axios.get('/deviceManage/api/admin/patrol-task', {
			params: {
				//这里是列表的名称
				community_id,
				device_type_id,
				task_name,
				task_state,
				task_start_date,
				task_end_date,
				page,
				limit
			},
			paramsSerializer(params) {
				return Qs.stringify(params);
			}
		})
	},
	add(
		//需要新增的数据（数据名称）
		community_id,
		device_type_id,
		task_name,
		task_start_date,
		task_end_date,
		cycle_type,
		day_data,
		week_data,
		month_data,
		year_data,
		task_start_time,
		manage_property,
		handle_property,
		device_ids,

	) {
		return Axios.post('/deviceManage/api/admin/patrol-task/add', {
			//和上面新增的数据相同
			community_id,
			device_type_id,
			task_name,
			task_start_date,
			task_end_date,
			cycle_type,
			day_data,
			week_data,
			month_data,
			year_data,
			task_start_time,
			manage_property,
			handle_property,
			device_ids,
		})
	},
	edit(
		id,
		community_id,
		device_type_id,
		task_name,
		task_start_date,
		task_end_date,
		cycle_type,
		day_data,
		week_data,
		month_data,
		year_data,
		task_start_time,
		manage_property,
		handle_property,
		device_ids,
	) {
		return Axios.patch(`/deviceManage/api/admin/patrol-task/${id}`, {
			community_id,
			device_type_id,
			task_name,
			task_start_date,
			task_end_date,
			cycle_type,
			day_data,
			week_data,
			month_data,
			year_data,
			task_start_time,
			manage_property,
			handle_property,
			device_ids,
		})

	},
	//删除
	del(
		//获取id
		id
	) {
		return Axios.delete(`/deviceManage/api/admin/patrol-task/${id}`, {
			//需要删除的内容
			data: {
				ids: [id]
			}
		})
	},
	//详情
	info(
		id
	) {
		return Axios.get(`/deviceManage/api/admin/patrol-task/${id}`);
	},

}